exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#youtube-iframe {\n  width: 100%;\n  height: 450px; }\n\n#video-tag {\n  width: 100%;\n  height: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/video/video.component.scss
// module id = ../../../../../src/app/components/video/video.component.scss
// module chunks = main